import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function MapPinIcon({ dark = false, ...props }: Props) {
  const { palette }: Theme = useTheme();
  const foreground = dark ? palette.accent.main : palette.primary.main;

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill={foreground}
        fillRule="evenodd"
        d="M8.53 5.34a6.89 6.89 0 017.04.05A7.33 7.33 0 0119 11.66c-.05 2.54-1.45 4.93-3.2 6.78-1 1.07-2.13 2.01-3.35 2.82-.13.07-.27.12-.4.14a.82.82 0 01-.4-.12 18.51 18.51 0 01-4.84-4.55A9.28 9.28 0 015 11.53a7.15 7.15 0 013.53-6.2zm1.26 7.25a2.38 2.38 0 003.88.8c.45-.45.7-1.07.7-1.71 0-.98-.57-1.87-1.46-2.25a2.35 2.35 0 00-2.6.52c-.68.7-.88 1.74-.52 2.64z"
        clipRule="evenodd"
      />
      <ellipse cx="12" cy="23.4" fill={foreground} opacity=".4" rx="5" ry="1" />
    </SvgIcon>
  );
}

export default memo(MapPinIcon);
